import { Link } from "react-router-dom";

export const ProductsPage = () => {
  return (
    <div className="bg-white">
      {/* Hero */}
      <section className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Our Products</h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Two focused products built for real user problems — options traders
            and global professionals navigating cross-border finances.
          </p>
        </div>
      </section>

      {/* Spread Genius */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-blue-50 to-indigo-100 rounded-2xl p-8 md:p-12 border border-blue-100">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="flex items-center gap-3 mb-6">
                  <span className="bg-blue-600 text-white px-4 py-1.5 rounded-full text-sm font-semibold">
                    Live
                  </span>
                  <span className="bg-white border border-blue-200 text-blue-700 px-4 py-1.5 rounded-full text-sm font-semibold">
                    Options Trading Analytics
                  </span>
                </div>

                <h2 className="text-4xl font-bold text-gray-900 mb-4">
                  Spread Genius
                </h2>

                <p className="text-lg text-gray-600 mb-6">
                  Upload broker CSV files to analyze your options spread
                  history. Upgrade to connect your Schwab account for live
                  positions, real-time option chains, and AI-powered trade
                  signals.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 mb-8">
                  {[
                    "Schwab & Fidelity CSV import",
                    "Auto strategy detection (20+ types)",
                    "P&L analytics and win rates",
                    "Live Schwab portfolio (Premium)",
                    "Covered call scanner (Premium)",
                    "Risk Radar dashboard (Premium)",
                    "CSP scoring (Premium)",
                    "High-conviction signals (Premium)",
                  ].map((f) => (
                    <div key={f} className="flex items-center gap-2 text-sm">
                      <svg
                        className="w-4 h-4 text-green-500 flex-shrink-0"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="text-gray-700">{f}</span>
                    </div>
                  ))}
                </div>

                <div className="flex flex-col sm:flex-row gap-4">
                  <Link
                    to="/products/spread-genius"
                    className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors inline-flex items-center justify-center"
                  >
                    Learn More
                    <svg
                      className="w-4 h-4 ml-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </Link>
                  <a
                    href="https://sprdgen.avtechai.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="border-2 border-blue-600 text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-600 hover:text-white transition-colors inline-flex items-center justify-center"
                  >
                    Launch App
                    <svg
                      className="w-4 h-4 ml-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      />
                    </svg>
                  </a>
                </div>
              </div>

              <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
                <div className="bg-gray-800 px-4 py-3 flex items-center space-x-2">
                  <div className="w-3 h-3 bg-red-500 rounded-full" />
                  <div className="w-3 h-3 bg-yellow-500 rounded-full" />
                  <div className="w-3 h-3 bg-green-500 rounded-full" />
                  <span className="text-gray-400 text-xs ml-2">
                    sprdgen.avtechai.com
                  </span>
                </div>
                <div className="aspect-video overflow-hidden">
                  <img
                    src="/screenshots/transaction-analysis.webp"
                    alt="Spread Genius dashboard"
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = "none";
                      const placeholder =
                        target.nextElementSibling as HTMLElement;
                      if (placeholder) placeholder.style.display = "flex";
                    }}
                  />
                </div>
                <div
                  className="hidden flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50 h-64 text-center p-6"
                  style={{ display: "none" }}
                >
                  <div className="grid grid-cols-3 gap-3 mb-4 w-full px-4">
                    <div className="bg-blue-200 rounded h-16" />
                    <div className="bg-indigo-200 rounded h-20" />
                    <div className="bg-purple-200 rounded h-14" />
                  </div>
                  <p className="text-blue-500 text-sm font-medium">
                    Transaction Analytics Dashboard
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Expat Horizon */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-slate-700 to-indigo-900 rounded-2xl p-8 md:p-12 text-white">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="flex items-center gap-3 mb-6">
                  <span className="bg-green-500 text-white px-4 py-1.5 rounded-full text-sm font-semibold">
                    Now Live
                  </span>
                  <span className="bg-white/10 border border-white/20 text-white px-4 py-1.5 rounded-full text-sm font-semibold">
                    Cross-Border Finance
                  </span>
                </div>

                <h2 className="text-4xl font-bold text-white mb-4">
                  Expat Horizon
                </h2>

                <p className="text-lg text-blue-200 mb-6">
                  Lifetime financial planning for Indian professionals living in
                  the US and Canada. Model retirement across multiple countries,
                  currencies, and tax systems with Monte Carlo projections.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 mb-8">
                  {[
                    "Monte Carlo retirement projections",
                    "US, Canada, India multi-country modeling",
                    "Cross-border withdrawal optimization",
                    "FBAR / FATCA compliance awareness",
                    "DTAA treaty benefit modeling",
                    "Household shared planning (couples)",
                    "401(k), IRA, PPF, NPS, RRSP support",
                    "Multi-currency net worth view",
                  ].map((f) => (
                    <div key={f} className="flex items-center gap-2 text-sm">
                      <svg
                        className="w-4 h-4 text-orange-300 flex-shrink-0"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="text-blue-100">{f}</span>
                    </div>
                  ))}
                </div>

                <div className="flex flex-col sm:flex-row gap-4">
                  <Link
                    to="/products/expat-horizon"
                    className="bg-orange-500 text-white px-8 py-3 rounded-lg font-semibold hover:bg-orange-400 transition-colors inline-flex items-center justify-center"
                  >
                    Learn More
                    <svg
                      className="w-4 h-4 ml-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </Link>
                  <a
                    href="https://expat-horizon.avtechai.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="border-2 border-white/40 text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/10 transition-colors inline-flex items-center justify-center"
                  >
                    Launch App
                  </a>
                </div>
              </div>

              <div className="bg-white/10 border border-white/20 rounded-2xl p-8">
                <h4 className="text-white font-semibold mb-6 text-center">
                  Built for the global Indian professional
                </h4>
                <div className="space-y-4">
                  {[
                    {
                      flag: "🇺🇸",
                      country: "United States",
                      note: "401(k), IRA, brokerage, HSA, FBAR",
                    },
                    {
                      flag: "🇨🇦",
                      country: "Canada",
                      note: "RRSP, TFSA, CPP, non-registered",
                    },
                    {
                      flag: "🇮🇳",
                      country: "India",
                      note: "PPF, NPS, FD, real estate, DTAA",
                    },
                  ].map(({ flag, country, note }) => (
                    <div
                      key={country}
                      className="flex items-center gap-4 bg-white/5 rounded-xl p-4"
                    >
                      <span className="text-3xl">{flag}</span>
                      <div>
                        <p className="font-semibold text-white">{country}</p>
                        <p className="text-blue-300 text-sm">{note}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Schwab CTA */}
      <section className="py-16 border-t">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="inline-flex items-center bg-green-50 border border-green-200 text-green-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <svg
              className="w-4 h-4 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
              />
            </svg>
            Charles Schwab Commercial API Integration
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-3">
            Spread Genius Premium is Powered by Schwab
          </h2>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            We're pursuing a commercial API license with Charles Schwab to give
            premium users secure, real-time access to their live brokerage data,
            option chains, and order placement — directly within Spread Genius.
          </p>
          <Link
            to="/schwab"
            className="bg-green-700 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-600 transition-colors inline-flex items-center"
          >
            View Schwab Integration Details
            <svg
              className="w-4 h-4 ml-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </Link>
        </div>
      </section>
    </div>
  );
};
